const mEditionAcademyUsersProfileSales = {
  mEditionAcademyUsersProfileSales: {
    free: 'Gratis',
    table: {
      thConcept: 'Detalle',
      thClient: 'Alumno',
      thDate: 'Fecha',
      thDiscount: 'Desc.',
      thMethod: 'Medio',
      thRecord: 'Ver',
      thToPay: 'A Pagar',
      thTotal: 'Total'
    },

    tooltip: {
      watch: 'Ver Detalles'
    }
  }
}

export default mEditionAcademyUsersProfileSales
